import type { FunctionComponent } from "react";
import { Routes } from "@/shared/types/enums/Routes.enum";
import { Link } from "react-router";
import { Button } from "@mui/material";
import { RiFolder5Line } from "@remixicon/react";

interface TableEmptyStateProps {
    title: string
    text: string
    buttonText: string
    href?: Routes
    onClick?: () => void
}

const TableEmptyState: FunctionComponent<TableEmptyStateProps> = ({
    title = 'Sin Registros Disponibles',
    text = 'Aun no cuentas con registros',
    buttonText = 'Crear',
    href = Routes.DEFAULT,
    onClick
}) => {
    return (
        <div className="flex flex-col items-center justify-center min-h-[300px] py-12 w-full">
            <div className="text-gray-400 mb-4">
                <RiFolder5Line size={48} />
            </div>
            <h5 className="text-center mb-2 text-gray-600 font-medium">
                {title}
            </h5>
            <p className="text-center text-gray-500 text-sm max-w-[350px]">
                {text}
            </p>
            {/* <Link to={href}>
                <Button variant="text">
                    {buttonText}
                </Button>
            </Link> */}
        </div>
    );
}

export default TableEmptyState;